export const clearTextFields = (
    site_nameRef,
    host_mid_nameRef,
    url_matchRef,
    table_nameRef,
    cart_urlRef,
    excluded_statesRef,
    cashback_affRef,
    normal_page_per_kRef,
    cart_page_perRef,
    min_no_visitsRef,
    countryRef,
    country_exceptRef,
    deviceRef,
    black_list_aff_wait_minRef,
    our_aff_wait_minRef,
    aff_activeRef,
    retargetting_activeRef,
    data_actRef,
    aff_wait_hrRef,
    store_IDRef,
    linkRef,
    ratioRef,
    typeRef,
    commentsRef

) => {
    site_nameRef.current.value = '';
    host_mid_nameRef.current.value = '';
    url_matchRef.current.value = '';
    table_nameRef.current.value = '';
    cart_urlRef.current.value = '';
    excluded_statesRef.current.value = '';
    cashback_affRef.current.value = '';
    normal_page_per_kRef.current.value = '';
    cart_page_perRef.current.value = '';
    min_no_visitsRef.current.value = '';
    countryRef.current.value = '';
    country_exceptRef.current.value = '';
    deviceRef.current.value = '';
    black_list_aff_wait_minRef.current.value = '';
    our_aff_wait_minRef.current.value = '';
    aff_activeRef.current.value = '';
    retargetting_activeRef.current.value = '';
    data_actRef.current.value = '';
    aff_wait_hrRef.current.value = '';
    store_IDRef.current.value = '';
    linkRef.current.value = '';
    ratioRef.current.value = '';
    typeRef.current.value = '';
    commentsRef.current.value = '';
};